import { useEffect } from "react";
import { API_OPTIONS } from "../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { addNowPlayingMovies } from "../utils/movieSlice";
import axios from "axios";
//fetching now playing videos and updating redux store
const useNowPlayingMovies = () => {
  const dispatch = useDispatch();
  const nowPlayingMovies = useSelector(
    (store) => store.movies.nowPlayingMovies,
  );

  const url = "https://api.themoviedb.org/3/movie/now_playing?page=1";

  async function getNowPlayingMovies() {
    try {
      const response = await axios.get(url, API_OPTIONS);
      let responseOK = response && response.status === 200;
      if (responseOK) {
        const data = await response.data;
        dispatch(addNowPlayingMovies(data.results));
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    !nowPlayingMovies && getNowPlayingMovies();
  }, []);
};

export default useNowPlayingMovies;
